/** Current (mutating) split settings. This object is kept in sync with splitio updates in redux. */
const SPLIT = {
  // [FEATURE]: { treatment, config }
};

// TODO: Delete after SL code is gone
window.SPLIT = SPLIT;

export default SPLIT;
